import React from 'react';
import { Line } from 'react-chartjs-2';
import { Box, useColorModeValue } from '@chakra-ui/react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Filler,
  Legend,
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Filler,
  Legend
);

const AssetTelemetryChart = ({ data = [], color = '#3182ce' }) => {
  const chartColor = color;
  const gridColor = useColorModeValue('rgba(0,0,0,0.05)', 'rgba(255,255,255,0.05)');
  const textColor = useColorModeValue('#718096', '#A0AEC0');

  // Logic to process raw readings into Chart.js format
  const chartData = {
    labels: data.map(r => new Date(r.timestamp).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })),
    datasets: [
      {
        fill: true,
        label: 'Pressure (PSI)',
        data: data.map(r => r.psi),
        borderColor: chartColor,
        backgroundColor: `${chartColor}20`, // Transparent fill
        borderWidth: 2,
        pointRadius: 0,
        pointHoverRadius: 5,
        tension: 0.4, // Smooth curves
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      tooltip: {
        mode: 'index',
        intersect: false,
        backgroundColor: useColorModeValue('white', '#2D3748'),
        titleColor: useColorModeValue('black', 'white'),
        bodyColor: useColorModeValue('black', 'white'),
        borderColor: chartColor,
        borderWidth: 1,
      },
    },
    scales: {
      x: {
        grid: { display: false },
        ticks: { color: textColor, maxRotation: 0, autoSkip: true, maxTicksLimit: 6 }
      },
      y: {
        grid: { color: gridColor },
        ticks: { color: textColor, stepSize: 10 }
      },
    },
  };

  return (
    <Box h="160px" w="100%">
      <Line data={chartData} options={options} />
    </Box>
  );
};

export default AssetTelemetryChart;